export const chartPeriodOptions = [
  { value: 'default', label: 'Padrão' },
  { value: 'past', label: 'Últimos 12 meses' },
  { value: 'future', label: 'Próximos 12 meses' },
];

export const getChartMonthRange = (period, now = new Date()) => {
  const currentMonth = now.getFullYear() * 12 + now.getMonth();
  const [start, end] = period === 'past' ? [-12, 0]
    : period === 'future' ? [0, 12] : [-6, 6];
  return { start: currentMonth + start, end: currentMonth + end };
};

export const isInChartMonthRange = (date, range) => {
  const match = /^(\d{4})-(\d{2})(?:-|$)/.exec(String(date ?? ''));
  if (!match) return false;
  const year = Number(match[1]);
  const month = Number(match[2]);
  if (month < 1 || month > 12) return false;
  const key = year * 12 + month - 1;
  return key >= range.start && key <= range.end;
};
